import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, DataFlightService, DataService, TopFlightsService, UtilityFlightService, UtilityService } from 'src/app/services';
import { Observable } from 'rxjs';
import { map, startWith, filter } from 'rxjs/operators';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export interface AIRPORT_LIST {
  city_name: string;
  airport_name: string;
  // city_code: string;
  flag: string;
  airport_code: string;
  country_code: string;
}
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD MMMM YYYY',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-flight-inner-header',
  templateUrl: './flight-inner-header.component.html',
  styleUrls: ['./flight-inner-header.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class FlightInnerHeaderComponent implements OnInit {
  @ViewChild('return_date_') returnDate: MatDatepicker<any>; 
  isDisabledRound: boolean = true;
  isShow = false;
  list;
  trip = this.data.trip_selected;
  booking_class;
  formModified: boolean = true;
  flightSearch: FormGroup;
  search_form: FormGroup;
  search_form_round: FormGroup;
  adult_value_;
  child_value_;
  infants_value_;
  isDisabledAdlt_Inc: boolean = false;
  isDisabledAdlt_Decr: boolean = true;
  isDisabledChild_Inc: boolean = false;
  isDisabledChild_Decr: boolean = true;
  isDisabledInfa_Inc: boolean = false;
  isDisabledInfa_Decr: boolean = true;
  passengers_booking_close: number = 0; // this is used in closed the popup box
  airport_list: any = [];
  citylist: AIRPORT_LIST[] = [];
  citylistTo: AIRPORT_LIST[] = [];
  filteredCities: Observable<AIRPORT_LIST[]>;
  filteredCitiesTo: Observable<AIRPORT_LIST[]>;
  // Form Selection
  travelling_from = new FormControl('', Validators.required);
  travelling_to = new FormControl('', Validators.required);
  trip_selected = new FormControl ('');
  onwarddate = new FormControl ('', Validators.required);
  returndate = new FormControl ('',);
  numadults = new FormControl ('');
  numchildren = new FormControl ('');
  numinfants = new FormControl ('');
  prefclass = new FormControl ('');
  numresults = new FormControl ('');
  prefcarrier = new FormControl ('');
  search_request = new FormControl ('');
  fare_type_select = new FormControl ('');
  returnDateMinDate: Date;
  minDate: Date;
  maxDate: Date;
  selected_form_value: any = [];
  selected_to_value: any = [];
  isDisabledApplyBtn: boolean = false;
  @ViewChild('travelling_from_input') inputField!: ElementRef; // Reference to the input element
  @ViewChild('travelling_to_input') inputFieldTo!: ElementRef; // Reference to the input element
  isInputFocused = false;
  isInputToFocused = false
  selectedDepartureDate;
  buttonModify
  currentDate: string | null = null;
  returnDateSelected;
  isSearchButtonDisabled: boolean = false;  // Initially enabled
  lastSelectedValue: string;
  lastSelectedValueTo: string;



  constructor(private data: DataService, private fb: FormBuilder, private util: UtilityService, private route: ActivatedRoute, private router: Router,
    private flights__: TopFlightsService, private utilFlight: UtilityFlightService, private authService: AuthService, private flightData: DataFlightService
  ) { 
    // this.flightData.flightInsurance.push({value: 0});
    // localStorage.removeItem('flightInsurance');
    // this.booking_class = JSON.parse(localStorage.getItem('booking_class'));
    this.flightData.getBookingClasses().subscribe(
      data => { this.booking_class = data; },
      err => { this.util.errorMessage(err); }
    );
    this.list = JSON.parse(localStorage.getItem('flight_search'));
    const CURRENT_URLAI = this.router.url.split('/').slice(-2, -1)[0] || '';
    if(this.list === null || this.list === undefined) {
      const originCode = 'DEL';
      const destinationCode = 'BOM';
      this.list = this.flights__.prepareFlightSearchDomestic__(originCode, destinationCode);
    }
    var airport_list = JSON.parse(localStorage.getItem('airport')!);
    // In this airport_list with country_code property
    airport_list.sort((a, b) => {
      if(a.country_code === 'IN' && b.country_code !== 'IN') {
        return -1 // Move a before b
      } else if (a.country_code === 'IN' && b.country_code !== 'IN') {
        return 1 // Move a before b
      } else {
        return 0
      }
    });
    const flightlist = airport_list.map(airport => ({
      ...airport,
      flag: this.data.getFlagIcon(airport.country_code),
    }));
    // console.log(flightlist);
    this.citylist = flightlist;
    this.citylistTo = flightlist;
    // filterCity in pipeline
    // this.filteredCities = this.travelling_from.valueChanges.pipe(
    //   startWith(''),
    //   map(airport_code => (airport_code ? this._filterStates(airport_code): this.citylist.slice(0, 15)))
    // );
    // this.filteredCitiesTo = this.travelling_to.valueChanges.pipe(
    //   startWith(''),
    //   map(airport_code => (airport_code ? this._filterStatesTo_(airport_code): this.citylistTo.slice(0, 15)))
    // );

    this.filteredCities = this.travelling_from.valueChanges.pipe(
      startWith(''),
      map(airport_code => {
        const filtered = airport_code ? this._filterStates(airport_code) : this.citylist.slice(0, 15);
        if (airport_code) {
          this.isSearchButtonDisabled = filtered.length === 0;
        } else {
          this.isSearchButtonDisabled = false; // btn enable when no input or selecting a valid city
        }
        return filtered;
      })
    );
    
    this.filteredCitiesTo = this.travelling_to.valueChanges.pipe(
      startWith(''),
      map(airport_code => {
        const filtered = airport_code ? this._filterStatesTo_(airport_code) : this.citylistTo.slice(0, 15);
        if (airport_code) {
          this.isSearchButtonDisabled = filtered.length === 0;
        } else {
          this.isSearchButtonDisabled = false; // btn enabled when no input or selecting a valid city
        }
        return filtered;
      })
    );
    
    
    const [airport, code] = this.router.url.split('/').pop()?.split('_') || [];
    const airportInfo = { airport, code: code?.toLowerCase() };
    const matchedFlight = flightlist.find(flight => flight.airport_code === airportInfo?.airport) || flightlist[0];

    this.utilFlight.currentDate$.subscribe(date => {
      this.currentDate = date;
      if (date !== null) {
        this.currentDate = date.toString();
        if (this.flightSearch) {  // Ensure flightSearch is defined
          this.flightSearch.patchValue({ onwarddate: this.currentDate });
          this.modifyFlightSearch();
        } else {
          console.error("flightSearch is not initialized.");
        }
      }
    });
    
    const updatedList = (CURRENT_URLAI === 'domestics' || CURRENT_URLAI === 'international' || CURRENT_URLAI === 'internationals') ? {
      ...this.list,
      origin: matchedFlight.city_code,
      search_request: {
        ...this.list.search_request,
        origin: matchedFlight
      }
    } : this.list;
    this.list = updatedList;
    
    if(this.list.trip === 1) {
      if(this.selected_form_value.length === 0) {
        this.selected_form_value = this.list.one_way.search_request.origin;
      }
      if(this.selected_to_value.length === 0) {
        this.selected_to_value = this.list.one_way.search_request.destination;
      }
    } else {
      if(this.selected_form_value.length === 0) {
        this.selected_form_value = this.list.search_request.origin;
      }
      if(this.selected_to_value.length === 0) {
        this.selected_to_value = this.list.search_request.destination;
      }
    }
    
    // Update button text based on the URL segment
    if (CURRENT_URLAI === 'domestics') {
      this.buttonModify = 'Search';
    } else if (CURRENT_URLAI === 'international' || CURRENT_URLAI === 'internationals') {
      this.buttonModify = 'Search';
    } else {
      this.buttonModify = 'Modify';
    }
    
    this.modifierSearch();
    
    this.flightSearch.valueChanges.subscribe(() => {
      this.formModified = true; // Set formModified to true when value changes
    });

    this.lastSelectedValue = 'New Delhi (DEL)';
    this.lastSelectedValueTo = 'Mumbai (BOM)';

 
    this.adult_value_ = parseInt(localStorage.getItem('adultValue')) || 1;
    this.isDisabledAdlt_Decr = this.adult_value_ <= 1; // Disable decrement if adult value is 1
    this.isDisabledAdlt_Inc = this.adult_value_ === 9; // Disable increment if adult value is 9
  }
  
  isSameCity(): boolean {
    return this.travelling_from.value === this.travelling_to.value;
  }

  // private _filterStates(city_code: string): AIRPORT_LIST[] {
  //   const filterValue = city_code.toLowerCase();
  //   const filteredResults = this.citylist.filter(state => {
  //     const city_name = state.city_name.toLowerCase();
  //     const airport_name = state.airport_name.toLowerCase();
  //     const city_code = state.airport_code.toLowerCase();
  //     return city_name.includes(filterValue) || airport_name.includes(filterValue) || city_code.includes(filterValue);
  //   });
  //   return filteredResults;
  // }

  // private _filterStatesTo_(city_code: string): AIRPORT_LIST[] {
  //   const filterValue = city_code.toLowerCase();
  //   const filteredResults = this.citylistTo.filter(state => {
  //     const city_name = state.city_name.toLowerCase();
  //     const airport_name = state.airport_name.toLowerCase();
  //     const city_code = state.airport_code.toLowerCase();
  //     return city_name.includes(filterValue) || airport_name.includes(filterValue) || city_code.includes(filterValue);
  //   });
  //   return filteredResults;
  // }

  private _filterStates(city_code: string): AIRPORT_LIST[] {
    const filterValue = city_code.toLowerCase();
  
    const getMatchPriority = (state: AIRPORT_LIST) => {
        const city_name = state.city_name.toLowerCase();
        const airport_name = state.airport_name.toLowerCase();
        const airport_code = state.airport_code.toLowerCase();
  
        const matchPriority = {
            codeMatch: airport_code.startsWith(filterValue),
            cityMatch: city_name.startsWith(filterValue),
            airportMatch: airport_name.startsWith(filterValue),
            isIndian: state.country_code === 'IN',
        };
        return matchPriority;
    };
  
    return this.citylist
        .map(state => ({
            state,
            matchPriority: getMatchPriority(state)
        }))
        .filter(({ matchPriority }) =>
            matchPriority.codeMatch || matchPriority.cityMatch || matchPriority.airportMatch
        )
        .sort(({ matchPriority: a, state: stateA }, { matchPriority: b, state: stateB }) => {
            if (a.isIndian && !b.isIndian) return -1;
            if (!a.isIndian && b.isIndian) return 1;   
            if (a.codeMatch && !b.codeMatch) return -1;
            if (!a.codeMatch && b.codeMatch) return 1;
            if (a.cityMatch && !b.cityMatch) return -1;
            if (!a.cityMatch && b.cityMatch) return 1;
            if (a.airportMatch && !b.airportMatch) return -1;
            if (!a.airportMatch && b.airportMatch) return 1;
            return 0; 
        })
        .map(({ state }) => state);  
  }
  
  private _filterStatesTo_(city_code: string): AIRPORT_LIST[] {
    const filterValue = city_code.toLowerCase();
    const getMatchPriority = (state: AIRPORT_LIST) => {
        const city_name = state.city_name.toLowerCase();
        const airport_name = state.airport_name.toLowerCase();
        const airport_code = state.airport_code.toLowerCase();
  
        const matchPriority = {
            codeMatch: airport_code.startsWith(filterValue),
            cityMatch: city_name.startsWith(filterValue),
            airportMatch: airport_name.startsWith(filterValue),
            isIndian: state.country_code === 'IN', 
        };
        return matchPriority;
    };
    return this.citylist
        .map(state => ({
            state,
            matchPriority: getMatchPriority(state)
        }))
        .filter(({ matchPriority }) =>
            matchPriority.codeMatch || matchPriority.cityMatch || matchPriority.airportMatch
        )
        .sort(({ matchPriority: a, state: stateA }, { matchPriority: b, state: stateB }) => {
            if (a.isIndian && !b.isIndian) return -1;
            if (!a.isIndian && b.isIndian) return 1;  
            if (a.codeMatch && !b.codeMatch) return -1;
            if (!a.codeMatch && b.codeMatch) return 1;
            if (a.cityMatch && !b.cityMatch) return -1;
            if (!a.cityMatch && b.cityMatch) return 1;
            if (a.airportMatch && !b.airportMatch) return -1;
            if (!a.airportMatch && b.airportMatch) return 1;
  
            return 0; 
        })
        .map(({ state }) => state);  
  }

  ngOnInit(): void {
    this.setMaxDate();
    this.minDate = new Date();

  const flightSearchData = JSON.parse(localStorage.getItem("flight_search") || '{}');
  if(flightSearchData?.trip === 1) {
    const adultValue = flightSearchData?.one_way?.numadults;
    const childValue = flightSearchData?.one_way?.numchildren;
    const infantsValue = flightSearchData?.one_way?.numinfants;
    // Parse and set the values, or use defaults
    this.adult_value_ = adultValue ? parseInt(adultValue, 10) : 1;
    this.child_value_ = childValue ? parseInt(childValue, 10) : 0;
    this.infants_value_ = infantsValue ? parseInt(infantsValue, 10) : 0;
    // console.log(adultValue, childValue, infantsValue);
    // console.log(flightSearchData);
  } else {
    const adultValue = flightSearchData?.numadults;
    const childValue = flightSearchData?.numchildren;
    const infantsValue = flightSearchData?.numinfants;
    // Parse and set the values, or use defaults
    this.adult_value_ = adultValue ? parseInt(adultValue, 10) : 1;
    this.child_value_ = childValue ? parseInt(childValue, 10) : 0;
    this.infants_value_ = infantsValue ? parseInt(infantsValue, 10) : 0;
    // console.log(this.adult_value_, this.child_value_, this.infants_value_);
  }
  // Update button states based on the loaded values
  this.updateButtonStates();
  this.returnDateSelected = flightSearchData?.onwarddate;
  
    this.flights__.flightSearchData$.subscribe(flight => {
    if (flight) {
      this.list = flight;
      const action = () => { this.list = JSON.parse(localStorage.getItem('flight_search')!); this.patchValue(); };
      window.location.pathname.includes('cheap-flights') ? setTimeout(action, 3000) : action();
    }
  });
  }

  selected_form(newValue) {
    this.selected_form_value = newValue;
    this.lastSelectedValue = newValue.city_name.concat(' (' + newValue.airport_code + ')');
  }
  selected_to(newValue) {
    this.selected_to_value = newValue;
    this.lastSelectedValueTo = newValue.city_name.concat(' (' + newValue.airport_code + ')');
  }
  
  


  handleBlur() {
    setTimeout(() => {
      const enteredValue = this.travelling_from.value.trim().toLowerCase();
      if (!enteredValue) {
        if (this.lastSelectedValue) {
          this.travelling_from.setValue(this.lastSelectedValue);
          this.isSearchButtonDisabled = false;
        } else {
          this.travelling_from.setValue('Mumbai (BOM)');
          this.isSearchButtonDisabled = false;
        }
        return;
      }
      const matchedOption = this.citylist.find(city => {
        const optionValue = city.city_name.concat(' (' + city.airport_code + ')').toLowerCase();
        return optionValue === enteredValue;
      });
      if (!matchedOption && this.lastSelectedValue) {
        this.travelling_from.setValue(this.lastSelectedValue);
      }
      this.isSearchButtonDisabled = false;
    }, 200);
  }


  handleBlurTo() {
    setTimeout(() => {
      const enteredValue = this.travelling_to.value?.trim().toLowerCase();
      if (!enteredValue) {
        // Auto-select last selected value if input is empty and lastSelectedValueTo is not empty
        if (this.lastSelectedValueTo) {
          this.travelling_to.setValue(this.lastSelectedValueTo);
          this.isSearchButtonDisabled = false;
        } else {
          // Default value if no last selected value
          this.travelling_to.setValue('Mumbai (BOM)');
          this.isSearchButtonDisabled = false;
        }
        return;
      }

      const matchedOption = this.citylist.find(city => {
        const optionValue = city.city_name.concat(' (' + city.airport_code + ')').toLowerCase();
        return optionValue === enteredValue;
      });

      if (!matchedOption && this.lastSelectedValueTo) {
        this.travelling_to.setValue(this.lastSelectedValueTo);
      }
      this.isSearchButtonDisabled =  false;
    }, 200);
  }

  clearSearch(inputControl) {
    inputControl.setValue(''); 
    inputControl.updateValueAndValidity(); 
  }

  removeFocus(): void {
    this.inputField.nativeElement.focus(); // Focus Traveller From input
    this.isInputFocused = true;
  }

  removeFocusTo(): void {
    this.inputFieldTo.nativeElement.focus(); // Focus Traveller To input
    this.isInputToFocused = true;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.isInputFocused && !this.inputField.nativeElement.contains(event.target)) {
      this.isInputFocused = false;
      this.inputField.nativeElement.blur(); // Blur Traveller From input
    }
    if (this.isInputToFocused && !this.inputFieldTo.nativeElement.contains(event.target)) {
      this.isInputToFocused = false;
      this.inputFieldTo.nativeElement.blur(); // Blur Traveller To input
    }
  }

  departureDateChanged(event: MatDatepickerInputEvent<Date>) {
    this.selectedDepartureDate = event.value;
    this.returnDateMinDate = this.selectedDepartureDate;
    // this.returndate.setValue(null);
    // this.trip_selected.setValue(0); 
    // if(this.tripSelectedlocal === 1){

    //   this.setReturnDate(this.selectedDepartureDate);
    // }
    
    if (this.trip_selected.value === 1) {
      this.setReturnDate(this.selectedDepartureDate);
    } 


  }

  setReturnDate(departureDate: Date): void {
    if (departureDate) {
      const returnDate = new Date(departureDate);
      returnDate.setDate(returnDate.getDate() + 1); 
      this.returndate.setValue(returnDate);
    }
  }



  getReturnDateMinDate(): Date {
    // return this.returnDateMinDate;

    const minDateFromDeparture = this.onwarddate.value ? new Date(this.onwarddate.value) : this.minDate;
    return this.returnDateMinDate > minDateFromDeparture ? this.returnDateMinDate : minDateFromDeparture;
  }

  setMaxDate(): void {
    const currentDate = new Date();
    this.maxDate = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
  }

  onReturnDateChanged() {
    this.trip_selected.setValue(1); 
  }

  roundWay_enable() {
    if (this.isDisabledRound === true) {
      this.isDisabledRound = false;
      this.trip_selected.setValue(1);
    } 
  }

  trip_selected_(event: any) {
    this.trip_selected.setValue(event?.value); 
    if (event?.value === 1) {
      if (!this.selectedDepartureDate) {

        const newReturnDate = new Date(this.returnDateSelected);
        newReturnDate.setDate(newReturnDate.getDate() + 1);
        this.returndate.setValue(newReturnDate);
        // const tomorrow = new Date();
        // tomorrow.setDate(tomorrow.getDate() + 2);
        // this.returndate.setValue(this.returnDateSelected);
      } else {
        const nextDay = new Date(this.selectedDepartureDate);
        console.log("nextDay", nextDay);
        
        nextDay.setDate(nextDay.getDate() + 1);
        this.returndate.setValue(nextDay); 
      }
    } else {
      this.returndate.setValue(null); 
    }
  }

  modifierSearch() {
    this.flightSearch = this.fb.group({
      credentials: this.util.getApiRequestCredentials(),
      trip_selected: this.trip_selected,
      travelling_from: this.travelling_from,
      travelling_to: this.travelling_to,
      onwarddate: this.onwarddate,
      returndate: this.returndate,
      prefclass: this.prefclass,
      numresults: this.numresults,
      numadults: this.numadults,
      numchildren: this.numchildren,
      numinfants: this.numinfants,
      prefcarrier: this.prefcarrier,
      fare_type_select: this.fare_type_select,
      search_request: this.search_request,
    });
    this.patchValue();
    // Set values for adult_value_, child_value_, and infants_value_
    this.adult_value_ = this.flightSearch.get('numadults').value;
    this.child_value_ = this.flightSearch.get('numchildren').value;
    this.infants_value_ = this.flightSearch.get('numinfants').value;
  }

  patchValue() {
    if(this.list.trip_selected === 0) {
      this.trip_selected.setValue(this.list.trip_selected);
      this.travelling_from.setValue(`${this.list.search_request.origin.city_name} (${this.list.search_request.origin.airport_code})`);
      this.travelling_to.setValue(`${this.list.search_request.destination.city_name} (${this.list.search_request.destination.airport_code})`);
      this.onwarddate.setValue(this.list.onwarddate);
      this.prefclass.setValue(this.list.prefclass);
      this.numresults.setValue(this.list.numresults);
      this.prefcarrier.setValue(this.list.prefcarrier);
      this.numadults.setValue(this.list.numadults);
      this.numchildren.setValue(this.list.numchildren);
      this.numinfants.setValue(this.list.numinfants);
      this.fare_type_select.setValue(this.list.fare_type_select);
      this.search_request.setValue(this.list.search_request)
    } else if(this.list.trip === 1) {
      this.trip_selected.setValue(this.list.trip);
      this.travelling_from.setValue(`${this.list.one_way.search_request.origin.city_name} (${this.list.one_way.search_request.origin.airport_code})`);
      this.travelling_to.setValue(`${this.list.one_way.search_request.destination.city_name} (${this.list.one_way.search_request.destination.airport_code})`);
      this.onwarddate.setValue(this.list.one_way.onwarddate);
      this.returndate.setValue(this.list.round_way.onwarddate);
      this.prefclass.setValue(this.list.one_way.prefclass);
      this.numresults.setValue(this.list.one_way.numresults);
      this.prefcarrier.setValue(this.list.one_way.prefcarrier);
      this.numadults.setValue(this.list.one_way.numadults);
      this.numchildren.setValue(this.list.one_way.numchildren);
      this.numinfants.setValue(this.list.one_way.numinfants);
      this.fare_type_select.setValue(this.list.fare_type_select);
      this.search_request.setValue(this.list.search_request)
    } else if (this.list.trip_selected === 1) {
      if(this.list.country_code === "i") {
        this.trip_selected.setValue(this.list.trip_selected);
        this.travelling_from.setValue(`${this.list.search_request.origin.city_name} (${this.list.search_request.origin.airport_code})`);
        this.travelling_to.setValue(`${this.list.search_request.destination.city_name} (${this.list.search_request.destination.airport_code})`);
        this.onwarddate.setValue(this.list.onwarddate);
        this.returndate.setValue(this.list.returndate);
        this.prefclass.setValue(this.list.prefclass);
        this.numresults.setValue(this.list.numresults);
        this.prefcarrier.setValue(this.list.prefcarrier);
        this.numadults.setValue(this.list.numadults);
        this.numchildren.setValue(this.list.numchildren);
        this.numinfants.setValue(this.list.numinfants);
      }
    }
  }

  passangerClass() {
    this.isShow = !this.isShow;
  }

  // selected_form(newvalue) {
  //   this.selected_form_value = newvalue;
  // }

  // selected_to(newValue) {
  //   this.selected_to_value = newValue;
  // }

  // This event used this closed the Popup passanger and Booking
  passangerClassOutside(e: Event) {
    this.passengers_booking_close++;
    if (this.passengers_booking_close > 1) {
      this.passangerClass();
      this.passengers_booking_close = 0;
    }
  }


  updateButtonStates() {
    // Adult button states
    this.isDisabledAdlt_Decr = this.adult_value_ <= 1;
    this.isDisabledAdlt_Inc = this.adult_value_ >= 9;

    // Child button states
    this.isDisabledChild_Decr = this.child_value_ <= 0;
    this.isDisabledChild_Inc = this.child_value_ >= 9;

    // Infants button states
    this.isDisabledInfa_Decr = this.infants_value_ <= 0;
    this.isDisabledInfa_Inc = this.infants_value_ >= 9 || this.infants_value_ >= this.adult_value_;

    // Apply button state
    this.isDisabledApplyBtn = this.adult_value_ < this.infants_value_;
  }

  // Adult decrement and increment methods
  adult_decr_() {
    if (this.adult_value_ > 1) {
      this.adult_value_--;
      localStorage.setItem('adultValue', this.adult_value_.toString());
    }
    this.updateButtonStates();
  }

  adult_incr_() {
    if (this.adult_value_ < 9) {
      this.adult_value_++;
      localStorage.setItem('adultValue', this.adult_value_.toString());
    }
    this.updateButtonStates();
  }

  // Child decrement and increment methods
  child_decr_() {
    if (this.child_value_ > 0) {
      this.child_value_--;
      localStorage.setItem('childValue', this.child_value_.toString());
    }
    this.updateButtonStates();
  }

  child_incr_() {
    if (this.child_value_ < 9) {
      this.child_value_++;
      localStorage.setItem('childValue', this.child_value_.toString());
    }
    this.updateButtonStates();
  }

  // Infant decrement and increment methods
  Infa_decr_() {
    if (this.infants_value_ > 0) {
      this.infants_value_--;
      localStorage.setItem('infantsValue', this.infants_value_.toString());
    }
    this.updateButtonStates();
  }

  Infa_incr_() {
    if (this.adult_value_ > this.infants_value_ && this.infants_value_ < 9) {
      this.infants_value_++;
      localStorage.setItem('infantsValue', this.infants_value_.toString());
    }
    this.updateButtonStates();
  }



  CancelReset() {
    this.isShow = false;
    this.updateButtonStates();
    this.modifyFlightSearch();
  }

  Applybtn(){
    this.isShow = false;
    this.updateButtonStates();
    this.modifyFlightSearch();
  }

  modifyFlightSearch() {
    this.formModified = false; // Reset formModified when the button is clicked
    if(this.flightSearch.valid){
      if(this.flightSearch.value.trip_selected === 0) {
        // This search is given on one way trip
        this.search_form = this.fb.group({
          credentials: this.util.getApiRequestCredentials(),
          trip_selected: this.flightSearch.value.trip_selected,
          origin: this.flightSearch.value.travelling_from.slice(-5).replace(/[()]/g, ''),
          destination: this.flightSearch.value.travelling_to.slice(-5).replace(/[()]/g, ''),
          onwarddate: this.util.formatDate(this.flightSearch.value.onwarddate, 'YYYY-MM-DD'),
          numadults: this.flightSearch.value.numadults,
          numchildren: this.flightSearch.value.numchildren,
          numinfants: this.flightSearch.value.numinfants,
          prefclass: this.flightSearch.value.prefclass,
          prefcarrier: this.flightSearch.value.prefcarrier,
          numresults: this.flightSearch.value.numresults,
          fare_type_select: this.flightSearch.value.fare_type_select,
          search_request: [{origin: this.selected_form_value, destination: this.selected_to_value }]//<!---->
        });
        if(this.search_form.valid) {
          localStorage.setItem('flight_search', JSON.stringify(this.search_form.value)!);
          const CURRENT_URLAI = this.router.url.split('/').slice(-2, -1)[0] || '';
          if (CURRENT_URLAI === 'domestics' || CURRENT_URLAI === 'international' || CURRENT_URLAI === 'internationals') {
            if(this.authService.loggedIn()) {
              this.router.navigate(['./u/flights/search']);
            } else {
              this.router.navigate(['search']);
            }
          } else {
            this.router.navigateByUrl('', {skipLocationChange: true}).then(() => {
              if(this.authService.loggedIn()) {
                this.router.navigate(['./u/flights/search']);
              } else {
                this.router.navigate(['search']);
              }
            });
          }
        }
      } else if(this.flightSearch.value.trip_selected === 1) {
        this.search_form = this.fb.group({
          credentials: this.util.getApiRequestCredentials(),
          trip_selected: this.flightSearch.value.trip_selected,
          origin: this.flightSearch.value.travelling_from.slice(-5).replace(/[()]/g, ''),
          destination: this.flightSearch.value.travelling_to.slice(-5).replace(/[()]/g, ''),
          onwarddate: this.util.formatDate(this.flightSearch.value.onwarddate, 'YYYY-MM-DD'),
          numadults: this.flightSearch.value.numadults,
          numchildren: this.flightSearch.value.numchildren,
          numinfants: this.flightSearch.value.numinfants,
          prefclass: this.flightSearch.value.prefclass,
          prefcarrier: this.flightSearch.value.prefcarrier,
          numresults: this.flightSearch.value.numresults,
          fare_type_select: this.flightSearch.value.fare_type_select,
          search_request: [{origin: this.selected_form_value, destination: this.selected_to_value }]
        });
        this.search_form_round = this.fb.group({
          credentials: this.util.getApiRequestCredentials(),
          trip_selected: this.flightSearch.value.trip_selected,
          origin: this.flightSearch.value.travelling_to.slice(-5).replace(/[()]/g, ''),
          destination: this.flightSearch.value.travelling_from.slice(-5).replace(/[()]/g, ''),
          onwarddate: this.util.formatDate(this.flightSearch.value.returndate, 'YYYY-MM-DD'),
          // return_date: this.return_date,
          numadults: this.flightSearch.value.numadults,
          numchildren: this.flightSearch.value.numchildren,
          numinfants: this.flightSearch.value.numinfants,
          prefclass: this.flightSearch.value.prefclass,
          prefcarrier: this.flightSearch.value.prefcarrier,
          numresults: this.flightSearch.value.numresults,
          fare_type_select: this.flightSearch.value.fare_type_select,
          search_request: [{origin: this.selected_to_value, destination: this.selected_form_value }]
        });
        console.log(this.flightSearch.value, this.search_form_round.value);
        if(this.search_form.valid || this.search_form_round.valid) {
          localStorage.setItem('flight_search', JSON.stringify({
            trip : this.flightSearch.value.trip_selected,
            trip_type: "i",
            one_way: this.search_form.value,
            round_way: this.search_form_round.value
          })!);
          this.router.navigateByUrl('', {skipLocationChange: true}).then(() => {
            if(this.authService.loggedIn()) {
              this.router.navigate(['./u/flights/search']);
            } else {
              this.router.navigate(['search']);
            }
          });
        }
      }
    }
  }



  
  // This Code used in Mobile Button
  modifierSearchMobile() {
    if(this.authService.loggedIn()) {
      this.router.navigate(['./u/flights/']);
    } else {
      this.router.navigate(['./flights/']);
    }
  }

  CHANGE_ROUND_TRIP() {
    this.returndate.setValue(null);
    this.trip_selected.setValue(0);
  }
}
